export const environment = {
  production: true,
  apiEndPoint: 'https://authenticator.yallasupermall.com',
  featureProductsLimit: 100,
  platform: 'storecloud',
  isStoreCloud: true,
  isMarketPlace: true,
  testing: false,
  excludingTenants: [0],
  defaultTenant: '3',
  referer: 2,
  merchantURL: 'https://merchant.yallasupermall.com',
  maintenanceMode: false,
  marketPlaceHostName: "yallasupermall.com",
  MediaBaseURL :"https://authenticator.yallasupermall.com/images/"
};
